import $ from 'jQuery';

function componentInit(parentElement)
{
  this.parentElement = null;

  this.construct = function(parentElement)
  {
    this.parentElement = parentElement;
  };

  this.run = function(parentElement)
  {
    var self = this;

    $(document).ready(function()
    {
      if(!parentElement)
        parentElement = self.parentElement;

      for(var key in self.callbacks)
        new self.callbacks[key](parentElement);
    });
  };

  this.construct(parentElement);
}

componentInit.prototype.callbacks = [];

export default componentInit;



// WEBPACK FOOTER //
// ./vendor/kuvio-framework/kustaa/applications/publicFrontend/scripts/components/componentInit.js